module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagination__options-quick-jumper"
  }, [_vm._v(_vm._s(_vm.gotoText)), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.page$),
      expression: "page$"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.page$)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$_changeValue($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.page$ = $event.target.value
      }
    }
  }), _vm._v(_vm._s(_vm.pText))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6806a2e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pager/elevator.vue
// module id = 379
// module chunks = 0